export const AIS_MODULE_PRESETS = [
    {
        id: 'module-1',
        module_number: 1,
        module_title: 'Introduction to AIS & MaceSuite',
        ais_cycle: 'AIS Foundation',
        required_workspace_tabs: ['Dashboard', 'Accounting Workspace', 'Guide'],
        expected_deliverables: ['AIS workflow reflection', 'Role and control checklist'],
    },
    {
        id: 'module-2',
        module_number: 2,
        module_title: 'Master Data & Process Documentation',
        ais_cycle: 'Master Data',
        required_workspace_tabs: ['Chart of Accounts', 'Supplier Master', 'Customer Master'],
        expected_deliverables: ['Master data setup evidence', 'COA/customer/supplier export'],
    },
    {
        id: 'module-3',
        module_number: 3,
        module_title: 'Revenue Cycle AIS',
        ais_cycle: 'Revenue Cycle',
        required_workspace_tabs: ['Customer Master', 'AR Invoice', 'AR Collections', 'AR Summary', 'AR Aging'],
        expected_deliverables: ['Posted revenue-cycle documents', 'AR report export', 'Manual JV impact explanation'],
    },
    {
        id: 'module-4',
        module_number: 4,
        module_title: 'Expenditure Cycle',
        ais_cycle: 'Expenditure Cycle',
        required_workspace_tabs: ['Supplier Master', 'AP Voucher', 'AP Payments', 'AP Summary', 'AP Aging'],
        expected_deliverables: ['Posted expenditure-cycle documents', 'AP report export', 'Manual JV impact explanation'],
    },
    {
        id: 'module-5',
        module_number: 5,
        module_title: 'Payroll Cycle',
        ais_cycle: 'Payroll Cycle',
        required_workspace_tabs: ['Employee Master', 'Journal Voucher', 'Trial Balance'],
        expected_deliverables: ['Payroll master data evidence', 'Salary entry support', 'Statutory compliance notes'],
    },
    {
        id: 'module-6',
        module_number: 6,
        module_title: 'Inventory Cycle',
        ais_cycle: 'Inventory Cycle',
        required_workspace_tabs: ['Inventory Master', 'Stock Monitoring', 'Journal Voucher', 'Trial Balance'],
        expected_deliverables: ['Inventory movement evidence', 'Stock reconciliation', 'Inventory accounting entries'],
    },
    {
        id: 'module-7',
        module_number: 7,
        module_title: 'Accounting Cycle',
        ais_cycle: 'Accounting Cycle',
        required_workspace_tabs: ['Opening Balances', 'Journal Voucher', 'General Ledger', 'Trial Balance', 'Income Statement', 'Balance Sheet'],
        expected_deliverables: ['Posted journal entries', 'Trial Balance PDF', 'Income Statement PDF', 'Balance Sheet PDF'],
    },
    {
        id: 'module-8',
        module_number: 8,
        module_title: 'Auditing & Controls',
        ais_cycle: 'Audit and Controls',
        required_workspace_tabs: ['Opening Balances', 'Journal Voucher', 'General Ledger', 'Trial Balance', 'Income Statement', 'Balance Sheet', 'Audit Trail'],
        expected_deliverables: ['Updated working file', 'Posted correcting JVs', 'Trial Balance PDF', 'Income Statement PDF', 'Balance Sheet PDF', 'Audit trail review'],
    },
];

export const findAisModulePreset = (moduleNumber) => (
    AIS_MODULE_PRESETS.find((preset) => String(preset.module_number) === String(moduleNumber))
);

export const hasAisModuleMetadata = (item = {}) => Boolean(
    item.module_number || item.module_title || item.ais_cycle
);

export const formatAisModuleLabel = (item = {}) => {
    if (!hasAisModuleMetadata(item)) return '';
    const number = item.module_number ? `Module ${item.module_number}` : 'AIS Module';
    return item.module_title ? `${number}: ${item.module_title}` : number;
};
